import { LOCATION_CHANGE } from 'connected-react-router';
import GoogleAnalytics, { trackPageView } from '@redux-beacon/google-analytics';
import { createMiddleware } from 'redux-beacon';
import { trackEvent } from '@redux-beacon/google-analytics';

const eventsMap = {
  [LOCATION_CHANGE]: trackPageView(action => {
    const site = action.payload.location.pathname.split('/')[1]
    return {
      page: action.payload.location.pathname.replace(`/${site}`, '')
    }
  }),
  'EVENT_ADD_INTEGRATION':  trackEvent((action, prevState, nextState) => {
    return {
      category: `admin.integration.${action.payload.name}`,
      label: action.payload.site,
      action: action.type
    };
  }),
  'EVENT_CRM_FILTER_CHANGED':  trackEvent((action, prevState, nextState) => {
    return {
      category: `crm.list.filter.${action.payload.name}`,
      label: action.payload.site,
      action: action.type,
    };
  }),
  'EVENT_CODE_FILTER_CHANGED':  trackEvent((action, prevState, nextState) => {
    return {
      category: `code.list.filter.${action.payload.name}`,
      label: action.payload.site,
      action: action.type,
    };
  }),
  'EVENT_CRM_OMNIFILTER_CHANGED':  trackEvent((action, prevState, nextState) => {
    return {
      category: `crm.list.omnifilter.${action.payload.name}`,
      label: action.payload.site,
      action: action.type,
    };
  }),
  'EVENT_CODE_OMNIFILTER_CHANGED':  trackEvent((action, prevState, nextState) => {
    return {
      category: `code.list.omnifilter.${action.payload.name}`,
      label: action.payload.site,
      action: action.type,
    };
  }),
  'EVENT_CRM_COLLAPSED_HEADER':  trackEvent((action, prevState, nextState) => {
    return {
      category: `${action.payload.state}`,
      label: action.payload.site,
      action: action.type
    };
  }),
  'EVENT_CMS_VISIBLE':  trackEvent((action, prevState, nextState) => {
    console.log("trackEvent: EVENT_CMS_VISIBLE", action);
    return {
      category: `cms.${action.payload.type}.visible`,
      action: action.type,
      label: action.payload.site
    }
  }),
  'EVENT_CMS_CTA':  trackEvent((action, prevState, nextState) => {
    console.log("trackEvent: EVENT_CMS_CTA", action);
    return {
      category: `cms.${action.payload.type}.cta`,
      action: action.type,
      label: action.payload.site
    };
  }),
  'EVENT_CODE_COLLAPSED_HEADER':  trackEvent((action, prevState, nextState) => {
    return {
      category: `${action.payload.state}`,
      label: action.payload.site,
      action: action.type
    };
  }),
};
export default createMiddleware(eventsMap, GoogleAnalytics());
